// frontend/src/services/baseUrl.ts
/**
 * Resolves the API base URL for both Electron and browser (CRA) builds.
 * Order of precedence:
 * 1) Electron preload bridge (window.demo.getApiBase)
 * 2) REACT_APP_API_BASE_URL (CRA)
 * 3) REACT_APP_API_PORT (CRA) -> http://127.0.0.1:${port}
 * 4) Default http://127.0.0.1:5000
 */
export async function getBaseUrl(): Promise<string> {
  // 1) Best: Electron preload exposes getApiBase
  try {
    // @ts-ignore - window.demo exists in Electron via preload
    const api = await window?.demo?.getApiBase?.();
    if (api && typeof api === 'string') return api;
  } catch (_) {
    // ignore and keep falling back
  }

  // 2) CRA env (explicit base URL for hosted frontend/backend)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const explicitBase = (process.env as any)?.REACT_APP_API_BASE_URL;
  if (explicitBase && typeof explicitBase === 'string' && explicitBase.trim()) {
    return explicitBase.trim().replace(/\/+$/, '');
  }

  // 3) CRA env (REACT_APP_API_PORT)
  const port =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (process.env as any)?.REACT_APP_API_PORT ||
    // also allow PORT for convenience during dev
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (process.env as any)?.PORT ||
    5000;

  // 4) Local default
  return `http://127.0.0.1:${port}`;
}
